import { Chakra } from "@airhelp/react-ui-components";
import type { ChakraProps } from "@chakra-ui/react";
import type { ReactNode } from "react";

const { Box } = Chakra;

const UlList = ({ children, styles }: { children: ReactNode; styles: ChakraProps["sx"] }) => (
  <Box as="ul" sx={styles}>
    {children}
  </Box>
);

export default UlList;
